export const xattributes = {
  items: [
    {
      id: "1",
      decimal: "1",
      attributeName: "Wypożyczalnia sprzętu zimowego",
      className: "winter-equip-rental"
    },
    {
      id: "2",
      decimal: "2",
      attributeName: "Sporty zimowe",
      className: "winter-sports"
    },
    {
      id: "3",
      decimal: "4",
      attributeName: "Blisko centrum",
      className: "near-center"
    },
    {
      id: "4",
      decimal: "8",
      attributeName: "Życie nocne",
      className: "night-life"
    },
    {
      id: "5",
      decimal: "16",
      attributeName: "Klimatyzacja",
      className: "air-conditioning"
    },
    {
      id: "6",
      decimal: "32",
      attributeName: "Dostęp do internetu",
      className: "internet-access"
    },
    {
      id: "7",
      decimal: "64",
      attributeName: "Zwierzęta domowe",
      className: "pets"
    },
    {
      id: "8",
      decimal: "128",
      attributeName: "Żeglarstwo",
      className: "sailing"
    },
    {
      id: "9",
      decimal: "256",
      attributeName: "Ułatwienia dla niepełnosprawnych",
      className: "disabled-facilities"
    },
    {
      id: "10",
      decimal: "512",
      attributeName: "Windsurfing",
      className: "windsurfing"
    },
    {
      id: "13",
      decimal: "4096",
      attributeName: "Nurkowanie",
      className: "diving"
    },
    {
      id: "14",
      decimal: "8192",
      attributeName: "Sporty wodne",
      className: "water-sports"
    },
    {
      id: "15",
      decimal: "16384",
      attributeName: "Minigolf",
      className: "minigolf"
    },
    {
      id: "16",
      decimal: "32768",
      attributeName: "Golf",
      className: "golf"
    },
    {
      id: "17",
      decimal: "65536",
      attributeName: "Tenis",
      className: "tennis"
    },
    {
      id: "18",
      decimal: "131072",
      attributeName: "Sport",
      className: "sport"
    },
    {
      id: "19",
      decimal: "262144",
      attributeName: "Animacje dla dorosłych",
      className: "adults-animations"
    },
    {
      id: "20",
      decimal: "524288",
      attributeName: "Blisko lotniska",
      className: "near-airport"
    },
    {
      id: "21",
      decimal: "1048576",
      attributeName: "Zjeżdżalnie wodne",
      className: "water-slides"
    },
    {
      id: "24",
      decimal: "8388608",
      attributeName: "Basen kryty",
      className: "indoor-pool"
    },
    {
      id: "25",
      decimal: "16777216",
      attributeName: "Basen odkryty",
      className: "outdoor-pool"
    },
    {
      id: "26",
      decimal: "33554432",
      attributeName: "Przy plaży",
      className: "next-to-beach"
    },
    {
      id: "27",
      decimal: "67108864",
      attributeName: "Fitness/siłownia",
      className: "gym"
    },
    {
      id: "28",
      decimal: "134217728",
      attributeName: "Hotel klubowy",
      className: "club-hotel"
    },
    {
      id: "29",
      decimal: "268435456",
      attributeName: "Dla rodzin z dziećmi",
      className: "families-childrens"
    },
    {
      id: "30",
      decimal: "536870912",
      attributeName: "Duże miasta (city breaks)",
      className: "city-breaks"
    },
    {
      id: "31",
      decimal: "1073741824",
      attributeName: "Kurorty nadmorskie",
      className: "seaside-resorts"
    },
    {
      id: "32",
      decimal: "2147483648",
      attributeName: "Ośrodki narciarskie",
      className: "ski-resorts"
    },
    {
      id: "36",
      decimal: "34359738368",
      attributeName: "Bez paszportu",
      className: "no-passport"
    },
    {
      id: "38",
      decimal: "137438953472",
      attributeName: "Blisko stoku",
      className: "near-slope"
    },
    {
      id: "39",
      decimal: "274877906944",
      attributeName: "Parking",
      className: "parking"
    },
    {
      id: "40",
      decimal: "549755813888",
      attributeName: "Kominek",
      className: "fireplace"
    },
    {
      id: "43",
      decimal: "4398046511104",
      attributeName: "Prywatny basen",
      className: "private-pool"
    },
    {
      id: "44",
      decimal: "8796093022208",
      attributeName: "Tylko dla gejów & przyjazne gejom",
      className: "gays"
    },
    {
      id: "46",
      decimal: "35184372088832",
      attributeName: "Wellness/SPA",
      className: "spa"
    },
    {
      id: "49",
      decimal: "281474976710656",
      attributeName: "Dla dorosłych",
      className: "for-adults"
    },
    {
      id: "50",
      decimal: "562949953421312",
      attributeName: "Darmowe Wi-Fi",
      className: "free-wifi"
    }
  ]
};
